import Vue from 'vue'
import Vuex from 'vuex'
import ApiCaller from '../utils/apicaller'
import constants from '../utils/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ads:[],
    adsTransaction: null
  },
  mutations: {
    'adsList': (state, payload) => {
      state.ads = payload
    },
    'AdsTransaction': (state, payload) => {
      state.adsTransaction = payload
    }
  }, 
  actions: {
    AdsCreation({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/campaign/add-ads`, "post", payload);
    },
    UpdateAds({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/campaign/update-ads`, "put", payload);
    },
    AdsDelete({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/campaign/delete/${payload}`, "delete");
    },
    Adslist({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/campaign/userAds`, "get");
    },
    AdsDetail({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/campaign/details/${payload}`, "get");
    },
    getJwt({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.GetJWT,payload, "get");
    },
    getWalletHistory({ commit }, { type, payload }) {
      console.log('=payload=store',payload)
      return ApiCaller(constants.BASE_URL,`/user/transaction-history`, "get");
    },
    getOrderResult({commit}, {type, payload}) {
      console.log('=-==payload transition===', payload)
      return ApiCaller(constants.BASE_URL2,`orderService/get-order-by-order-id/${payload}`, "get");
    },
    userDetail({ commit }, { type, payload }) {
      // get-user-count-for-pincodes/201301,201305
      return ApiCaller(constants.BASE_API_URL,`/user_details`, "get"); 
   },
   PincodeSupport({ commit }, { type, payload }) {
    // get-user-count-for-pincodes/201301,201305
    return ApiCaller(constants.Payboard,`/get-user-count-for-pincodes/${payload}`, "get"); 
   },
  },
  modules: {
  }
})
